export enum TicketStatus {
  open = 'open',
  inProgress = 'in_progress',
  waitingForCustomer = 'waiting_for_customer',
  resolved = 'resolved',
  closed = 'closed',
}

export enum TicketPriority {
  low = 'low',
  medium = 'medium',
  high = 'high',
  urgent = 'urgent',
}

export enum TicketType {
  technical = 'technical',
  billing = 'billing',
  account = 'account',
  feature = 'feature',
  bug = 'bug',
  other = 'other',
}

export enum TicketSource {
  member = 'member',
  employer = 'employer',
  provider = 'provider',
  internal = 'internal',
}

export interface HelpdeskTicket {
  id: string;
  ticketNumber: string; // Human-readable ticket number (e.g., TKT-2024-001)
  title: string;
  description: string;
  type: TicketType;
  priority: TicketPriority;
  status: TicketStatus;
  source: TicketSource;
  
  // User information
  createdBy: string; // User ID
  createdByName?: string; // User's name for display
  createdByEmail?: string; // User's email
  assignedTo?: string; // Operations staff user ID
  assignedToName?: string; // Staff name for display
  
  // Related entities
  relatedEmployerId?: string;
  relatedMemberId?: string;
  relatedProviderId?: string;
  relatedReceiptId?: string;
  
  // Comments/Conversation
  comments: TicketComment[];
  
  // Metadata
  tags: string[];
  metadata?: Record<string, unknown>;
  
  // Timestamps
  createdAt: Date;
  updatedAt: Date;
  resolvedAt?: Date;
  closedAt?: Date;
  firstResponseAt?: Date; // When staff first responded
  lastResponseAt?: Date; // Last staff response time
}

export interface TicketComment {
  id: string;
  ticketId: string;
  authorId: string;
  authorName: string;
  authorEmail?: string;
  isInternal: boolean; // If true, only visible to staff
  content: string;
  attachments?: string[]; // URLs to attached files
  createdAt: Date;
}

